export const getUserV2 = () => `/v2/users/{user_id}`;
